// extracted by mini-css-extract-plugin
module.exports = {"pointsList":"PointsList_pointsList__1Ykg2","pointItem":"PointsList_pointItem__1Mt5V"};